import { recipientStates } from "../../template/AccountTransfer/WireTransfer/data";
import { StepData } from "./Stepper";

export const stepperData: StepData[] = [
  {
    label: "Verify your business",
    path: "",
    subSteps: [
      {
        label: "Business Details",
        path: "",
        formFields: [
          {
            label: "Legal Business Name",
            type: "input",
            placeholder: "Company",
            info: "Business name must be registered",
            name: "businessName",
            inputType: "text",
          },
          {
            label: "Employee Identification Number (EIN)",
            type: "input",
            placeholder: "12-3456789",
            info: "Enter your Employee Identification Number (EIN)",
            name: "EIN",
            inputType: "number",
          },
          {
            label: "Doing business as (Optional)",
            type: "input",
            placeholder: "",
            name: "doingBusiness",
            inputType: "text",
          },
          {
            label: "Registered Business Country",
            type: "input",
            placeholder: "United States",
            name: "businessCountry",
            inputType: "text",
            disabled: true,
            value: "United States",
          },
          {
            label: "Address 1",
            type: "input",
            name: "address1",
            inputType: "text",
          },
          {
            label: "Address 2",
            type: "input",
            name: "address2",
            inputType: "text",
          },
          {
            label: "City",
            type: "input",
            name: "city",
            inputType: "text",
          },
          {
            label: "State",
            type: "select",
            placeholder: "Select",
            name: "businessState",
            options: recipientStates,
          },
          {
            label: "Zip",
            type: "input",
            name: "zip",
            inputType: "text",
          },
          {
            label: "Business Website",
            type: "input",
            name: "businessWebsite",
            inputType: "text",
            placeholder: "www.example.com",
          },
          {
            label: "Product Description",
            type: "textArea",
            name: "product",
            inputType: "text",
          },
        ],
        subTitle: "Provide your business information",
      },
      {
        label: "Personal Details",
        path: "",
        formFields: [
          {
            label: "Full Name",
            type: "input",
            name: "name",
            inputType: "text",
            placeholder: "Jane Doe",
          },
          {
            label: "Email Address",
            type: "input",
            name: "email",
            inputType: "text",
            placeholder: "janedoe@gmail.com",
          },
          {
            label: "Date of Birth",
            type: "input",
            name: "name",
            inputType: "text",
            placeholder: "MM/DD/YY",
            icon: "/assets/svg/calendar.svg",
          },
          {
            label: "Customer Support Phone Number",
            type: "input",
            name: "phoneNumber",
            inputType: "tel",
            placeholder: "(201) 363-8345",
          },
          {
            label: "Social Security Number (SSN)",
            type: "input",
            name: "ssn",
            inputType: "text",
          },
          {
            label: "Home Country",
            type: "input",
            placeholder: "United States",
            name: "homCountry",
            inputType: "text",
            disabled: true,
          },
          {
            label: "Address 1",
            type: "input",
            name: "address1",
            inputType: "text",
          },
          {
            label: "Address 2",
            type: "input",
            name: "address2",
            inputType: "text",
          },
          {
            label: "City",
            type: "input",
            name: "city",
            inputType: "text",
          },
          {
            label: "State",
            type: "select",
            placeholder: "Select",
            name: "personalState",
            options: recipientStates,
          },
          {
            label: "Zip",
            type: "input",
            name: "zip",
            inputType: "text",
          },
        ],
        subTitle: "Add your public details for customers",
      },
      {
        label: "Order details",
        path: "",
        formFields: [
          {
            label: "Do you sell physical goods?",
            name: "sell",
            inputType: "text",
            type: "radio",
            radioOption: {
              label: "Yes",
              value: "Yes",
            },
          },
          {
            name: "sell",
            inputType: "text",
            type: "radio",
            radioOption: {
              label: "No",
              value: "No",
            },
          },
          {
            label: "Do you ship the product yourself?",
            name: "ship",
            inputType: "text",
            type: "radio",
            radioOption: {
              label: "Yes",
              value: "Yes",
            },
          },
          {
            name: "ship",
            inputType: "text",
            type: "radio",
            radioOption: {
              label: "No",
              value: "No",
            },
          },
          {
            label:
              "On average, how long after paying will your customers typically receive their goods or services?",
            type: "select",
            name: "deliveryDuration",
            placeholder: "Select",
            options: [
              "Within one day",
              "Within two weeks",
              "Within one month",
              "More than one month",
            ],
          },
        ],
        subTitle: "Describe how you fulfill your orders",
        hasOneCol: true,
      },
      {
        label: "Public Details",
        path: "",
        formFields: [
          {
            label: "Statement Descriptor",
            type: "input",
            name: "statementDescriptor",
            inputType: "text",
            placeholder: "Your business name",
            info: "Description",
          },
          {
            label: "Shortened Descriptor",
            type: "input",
            name: "shortenedDescriptor",
            inputType: "text",
            placeholder: "Business Description Details",
            info: "Description",
          },
          {
            label: "Customer Support Phone Number",
            type: "input",
            name: "phoneNumber",
            inputType: "tel",
            placeholder: "(201) 363-8345",
          },
          {
            label: "Customer Support Country",
            type: "input",
            placeholder: "United States",
            name: "customerSupportCountry",
            inputType: "text",
            disabled: true,
          },
          {
            label: "Address 1",
            type: "input",
            name: "address1",
            inputType: "text",
          },
          {
            label: "Address 2",
            type: "input",
            name: "address2",
            inputType: "text",
          },
          {
            label: "City",
            type: "input",
            name: "city",
            inputType: "text",
          },
          {
            label: "State",
            type: "select",
            placeholder: "Select",
            name: "personalState",
            options: recipientStates,
          },
          {
            label: "Zip",
            type: "input",
            name: "zip",
            inputType: "text",
          },
        ],
        subTitle: "Add your public details for customers",
      },
    ],
  },
  {
    label: "Add your bank",
    path: "",
    subSteps: [
      {
        label: "Bank Details",
        path: "",
        formFields: [
          {
            label: "Routing number",
            type: "input",
            name: "routingNumber",
            inputType: "number",
            placeholder: "Routing Number",
            info: "Enter your routing number",
          },
          {
            label: "Account number",
            type: "input",
            name: "AccountNumber",
            inputType: "number",
            placeholder: "Account Number",
            info: "Enter your account number",
          },
          {
            label: "Confirm account number",
            type: "input",
            name: "ConfirmAccountNumber",
            inputType: "number",
            placeholder: "Confirm account number",
            info: "Confirm your account number",
          },
        ],
        subTitle: "Checking and savings accounts are supported.",
      },
    ],
  },
  {
    label: "Secure your account",
    path: "",
    subSteps: [
      {
        label: "Two step authentication",
        path: "",
        formFields: [
          {
            name: "authentication",
            inputType: "text",
            type: "radio",
            radioOption: {
              label: "Use SMS",
              value: "Use SMS",
              subText:
                "You’ll receive a one-time code via SMS to verify your identity",
            },
          },
          {
            name: "authentication",
            inputType: "text",
            type: "radio",
            radioOption: {
              label: "Add a security key",
              value: "security key",
              subText:
                "Use a small USB key to provide an additional layer of security to your login process.",
            },
          },
        ],
        subTitle:
          "Keep your account secure. We recommend that you enable various kinds of two-step authentication as a backup incase you lose your mobile device or service.",
        secondSubTitle:
          "Fipay requires two-factor authentication to keep your account secure. Using your password ensures that no one else can get in to your account",
        hasOneCol: true,
      },
    ],
  },
  {
    label: "Tax",
    path: "",
    subSteps: [
      {
        label: "Calculate your tax",
        path: "",
        formFields: [],
        subTitle: "",
        hasOneCol: true,
      },
    ],
  },
  {
    label: "Review",
    path: "",
    subSteps: [
      {
        label: "Summary",
        path: "",
        formFields: [],
        subTitle: "",
        hasOneCol: false,
      },
    ],
  },
];
